export default
{
    methods:
    {
        prevMonthClick()
        {
            this.changeMonthDate( this.$dateUtil.prevMonth( this.currentMonthDate ) )
        },

        nextMonthClick()
        {
            this.changeMonthDate( this.$dateUtil.nextMonth( this.currentMonthDate ) )
        },

        dateClick( date )
        {
            //TODO BRAT DO UVAHY TIMEPICKER

            let dt  = new Date( date ); dt.setHours(0, 0, 0, 0);

            let min = this.minDate ? new Date( this.minDate ) : null; min && min.setHours(0, 0, 0, 0);
            let max = this.maxDate ? new Date( this.maxDate ) : null; max && max.setHours(0, 0, 0, 0);

            if( ( min && dt.getTime() < min.getTime() ) || ( max && dt.getTime() > max.getTime() ) )
            {
                return;
            }

            this.$emit( 'dateClick', date )
        },

        changeMonthDate( date, emit = true )
        {
            let year_month = this.$dateUtil.yearMonth( this.currentMonthDate );

            this.currentMonthDate = this.$dateUtil.validateDateRange( date, this.minDate, this.maxDate );

            if( emit && year_month !== this.$dateUtil.yearMonth( this.currentMonthDate ) )
            {
                this.$emit('change-month', { month: ( new Date( this.currentMonthDate ) ).getMonth() + 1, year: ( new Date( this.currentMonthDate ) ).getFullYear() })
            }

            this.checkYear()
        },

        dayClass( date )
        {
            //TODO BRAT DO UVAHY TIMEPICKER

            let dt = new Date( date ); dt.setHours(0, 0, 0, 0);

            let min          = this.minDate ? new Date( this.minDate ) : null; min && min.setHours(0, 0, 0, 0);
            let min_previous = this.minDate ? new Date( this.minDate ) : null; min_previous && min_previous.setHours(0, 0, 0, 0); min_previous && min_previous.setDate( min_previous.getDate() - 1 );

            let max      = this.maxDate ? new Date( this.maxDate ) : null; max && max.setHours(0, 0, 0, 0);
            let max_next = this.maxDate ? new Date( this.maxDate ) : null; max_next && max_next.setHours(0, 0, 0, 0); max_next && max_next.setDate( max_next.getDate() + 1 );

            let start = new Date( this.start ); start.setHours(0, 0, 0, 0);
            let end   = new Date( this.end ); end.setHours(0, 0, 0, 0);

            let classes = {};

            if( date.getMonth() + 1 !== this.month )
            {
                classes = { 'off': true }
            }
            else
            {
                let isWeekend = date.getDay() === 6 || date.getDay() === 0,
                    isToday   = dt.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0),
                    isActive  = dt.setHours(0, 0, 0, 0) === new Date( this.start ).setHours(0, 0, 0, 0) || dt.setHours(0, 0, 0, 0) === new Date( this.end ).setHours(0, 0, 0, 0),
                    inRange   = dt >= start && dt <= end,
                    startDate = dt.getTime() === start.getTime(),
                    endDate   = dt.getTime() === end.getTime(),
                    disabled  = ( min && dt.getTime() < min.getTime() ) || ( max && dt.getTime() > max.getTime() );

                classes =
                {
                    'weekend'           : isWeekend,
                    'today'             : isToday,
                    'active'            : !disabled && isActive,
                    'in-range'          : !disabled && inRange,
                    'start-date'        : !disabled && startDate,
                    'end-date'          : !disabled && endDate,
                    'disabled'          : disabled,
                    'disabled-min-first': false,
                    'disabled-min-last' : ( min_previous && dt.getTime() === min_previous.getTime() ),
                    'disabled-max-first': ( max_next && dt.getTime() === max_next.getTime() ),
                    'disabled-max-last' : false
                }
            }

            return this.dateFormat ? this.dateFormat( classes, date ) : classes;
        },

        checkYear()
        {
            if( this.$refs.yearSelect !== document.activeElement )
            {
                this.$nextTick(() => { this.year_text = this.monthDate.getFullYear() })
            }
        }
    }
}